<template>
  <div class="reservationSearchResults">
    <div v-if="!data?.length" class="reservationSearchResults__NoResults">{{ $t('reservation.noResults') }}</div>
    <template v-else>
      <div v-for="item in data" class="reservationSearchResults__SearchCategory">
        <button @click="setLocation(item)">
          <template v-if="!item.accommodations">
            <template v-if="item.type === 'HOTEL'"><Icon name="hotel" /></template>
            <template v-else><Icon name="campsite" /></template>
          </template>
          <template v-else><Icon name="location" /></template>
          <span v-html="item.displayTitle" />
        </button>
      </div>
    </template>
  </div>
</template>

<script setup>
  defineProps({
    data: {},
  });

  const emit = defineEmits(['setLocation']);

  const setLocation = (location) => {
    emit('setLocation', location);
  };
</script>

<style lang="scss">
  @import url('@/assets/styles/components/_reservationSearchResults.scss');
</style>